import * as TP from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetConnectCarrierSearchQueryVariables = TP.Exact<{
  input: TP.GetConnectCarrierSearchInput;
}>;


export type GetConnectCarrierSearchQuery = (
  { readonly __typename?: 'Query' }
  & { readonly getConnectCarrierSearch: (
    { readonly __typename?: 'GetConnectCarrierSearchPayload' }
    & Pick<TP.GetConnectCarrierSearchPayload, 'totalCount'>
    & { readonly results?: TP.Maybe<ReadonlyArray<(
      { readonly __typename?: 'CarrierSearchResult' }
      & Pick<TP.CarrierSearchResult, 'routeCode' | 'availablePuDate' | 'originStopCity' | 'originStopState' | 'destStopCity' | 'destStopState' | 'routeLifeCycleStatus' | 'offerStatus' | 'targetTab' | 'routeId' | 'tenderPlanId' | 'tenderId' | 'offerId'>
    )>>, readonly errors?: TP.Maybe<ReadonlyArray<(
      { readonly __typename?: 'CarrierConnectError' }
      & Pick<TP.CarrierConnectError, 'message' | 'code' | 'errorType'>
    )>> }
  ) }
);


export const GetConnectCarrierSearchDocument = gql`
    query GetConnectCarrierSearch($input: GetConnectCarrierSearchInput!) {
  getConnectCarrierSearch(input: $input) {
    results {
      routeCode
      availablePuDate
      originStopCity
      originStopState
      destStopCity
      destStopState
      routeLifeCycleStatus
      offerStatus
      targetTab
      routeId
      tenderPlanId
      tenderId
      offerId
    }
    totalCount
    errors {
      message
      code
      errorType
    }
  }
}
    `;

/**
 * __useGetConnectCarrierSearchQuery__
 *
 * To run a query within a React component, call `useGetConnectCarrierSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConnectCarrierSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConnectCarrierSearchQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetConnectCarrierSearchQuery(baseOptions: Apollo.QueryHookOptions<GetConnectCarrierSearchQuery, GetConnectCarrierSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConnectCarrierSearchQuery, GetConnectCarrierSearchQueryVariables>(GetConnectCarrierSearchDocument, options);
      }
export function useGetConnectCarrierSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConnectCarrierSearchQuery, GetConnectCarrierSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConnectCarrierSearchQuery, GetConnectCarrierSearchQueryVariables>(GetConnectCarrierSearchDocument, options);
        }
export type GetConnectCarrierSearchQueryHookResult = ReturnType<typeof useGetConnectCarrierSearchQuery>;
export type GetConnectCarrierSearchLazyQueryHookResult = ReturnType<typeof useGetConnectCarrierSearchLazyQuery>;
export type GetConnectCarrierSearchQueryResult = Apollo.QueryResult<GetConnectCarrierSearchQuery, GetConnectCarrierSearchQueryVariables>;